import React from 'react'
import { useMediaQuery } from 'react-responsive';


const plug_data = [
  {
    id: "1",
    icon: '/assets/images/kwikwoocomm/slow.png',
    text: "Plugin dependency chaos = slow checkout process",
  },
  {
    id: "2",
    icon: '/assets/images/kwikwoocomm/address.png',
    text: "No address prefill or smart address validation",
  },
  {
    id: "3",
    icon: '/assets/images/kwikwoocomm/scan.png',
    text: "No built-in system to detect and block high-risk COD orders.",
  },
  {
    id: "4",
    icon: '/assets/images/kwikwoocomm/credit.png',
    text: "Limited payment options with poor fallback",
  },


]


const SectionThree = () => {

  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div>
      <div className='section-three-woo' style={{ backgroundColor: "#fff" }}>
        <div style={{ backgroundColor: isMobile && "#FCEAD1" }}>
          {
            isMobile ? (
              <div className='plugin-section-mob'>
                <div className='plug-h1-mob'>
                  <h1>
                    A Heavy Plugin Stack Kills Your Conversions and Performance
                  </h1>
                </div>

                <div className='plug-card-mob'>
                  <div className='plug-img-card-mob'>
                    <img src="/assets/images/kwikwoocomm/plugin-img.png" alt="woo-plugin" />
                  </div>
                  <div className="plug-scroll-container-mob">
                    <div className="fade-left"></div>
                    <div className="fade-right"></div>
                    <div className="plug-cards-scroll-mob">
                      {[...plug_data, ...plug_data].map((data, idx) => (
                        <div className="plug-cards-mob" key={idx}>
                          <img src={data.icon} alt="" style={{ width: "47px", height: "47px" }} />
                          {data.text}
                        </div>
                      ))}
                    </div>
                  </div>


                </div>

              </div>
            ) : (
              <div className='section-plug-Woo'>
                <div className='plugin-section'>
                  <div className='plug-h1'>
                    <h1>
                      A Heavy Plugin Stack Kills Your Conversions and Performance
                    </h1>
                  </div >

                  <div className='plug-card col-md-12'>
                    <div className='plug-img-card col-md-9'>
                      <img src="/assets/images/kwikwoocomm/plugin-img.png" alt="woo-plugin" />
                    </div>
                    <div className="plug-scroll-container col-md-2.5">
                      <div className="fade-top"></div>
                      <div className="fade-bottom"></div>
                      <div className="plug-cards-scroll">
                        {[...plug_data, ...plug_data].map((data, idx) => (
                          <div className="plug-cards" key={idx}>
                            <img src={data.icon} alt="" style={{ width: "47px", height: "47px" }} />
                            <div>
                              {data.text}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>


                </div>

              </div >
            )
          }

        </div >

        <div className="secfive-wrapper secfive-wrapper-mob position-relative overflow-hidden">
          {
            isMobile ? (
              <div
                className="secfive-container"
                style={{
                  // minHeight: isMobile ? "auto" : "50vh",
                  color: "black",
                  zIndex: 1,
                  position: "relative",
                }}
              >
                <div>
                  <div className="secfive-content secfive-content-mob">
                    <div className="secfive-left">
                      <p className="secfive-quote secfive-quote-mob">“With KwikCheckout, our conversion rate is 35%, ROAS improved, and prepaid orders jumped to around 45%. Plus, the support has been excellent.”</p>
                      <div className="secfive-founder-info">
                        <p className="secfive-founder-name">Abdus Samad, Founder</p>
                        <img
                          src='/assets/images/kwikwoocomm/sam-marshall.png'
                          alt='sam-marshall'
                          className="secfive-logo"
                        />
                      </div>
                    </div>
                    <div className={isMobile ? "secfive-top-mob" : "secfive-right"}>
                      <h1 className={isMobile ? "secfive-percent-mob" : "secfive-percent"}>35%</h1>
                      <p className={isMobile ? "secfive-label-mob" : "secfive-label"} >Conversions</p>
                    </div>
                  </div>
                </div>

              </div>
            ) : (
              <div
                className="secfive-container"
                style={{
                  // minHeight: isMobile ? "auto" : "50vh",
                  color: "black",
                  zIndex: 1,
                  position: "relative",
                }}
              >

                <div>
                  <div className="secfive-content">
                    <div className="secfive-left">
                      <p className="secfive-quote">“With KwikCheckout, our conversion rate is 35%, ROAS improved, and prepaid orders jumped to around 45%. Plus, the support has been excellent.”</p>
                      <div className="secfive-founder-info">
                        <p className="secfive-founder-name">Abdus Samad, Founder</p>
                        <img
                          src='/assets/images/kwikwoocomm/sam-marshall.png'
                          alt='sam-marshall'
                          className="secfive-logo"
                        />
                      </div>
                    </div>
                    <div className="secfive-right">
                      <h1 className="secfive-percent">35%</h1>
                      <p className="secfive-label">Conversions</p>
                    </div>
                  </div>
                </div>

              </div>
            )
          }
        </div>

        <div>
          {
            isMobile ? (
              <div className='woo-network' style={{ padding: isMobile && '28px' }}>
                <h1>Tap into GoKwik's  <br /> <span style={{ border: '3px solid #0285FB', borderRadius: "15px", padding: '0px 5px', boxShadow: "0px 4px 20px 0px #0285fbad" }}>165 M+ Shoppers Network</span></h1>
                <p style={{ maxWidth: isMobile && '300px' }}>Access the largest network of online shoppers to boost engagement and conversions</p>

                <div className='woo-net-card-mob'>
                  <div className='outer-mob'>
                    <div className='inner-mob woo-net-card1'>
                      <img src="/assets/images/kwikwoocomm/frame1.png" alt="" />
                      <div>
                        <h1>200+</h1>
                        <p>Signals for risk profiling</p>
                      </div>
                    </div>
                  </div>
                  <div className='outer-mob'>
                    <div className='inner-mob woo-net-card2'>
                      <img src="/assets/images/kwikwoocomm/frame2.png" alt="" />
                      <div>
                        <h1>1.5 Bn+</h1>
                        <p>Click stream data points</p>
                      </div>
                    </div>
                  </div>
                  <div className='outer-mob'>
                    <div className='inner-mob woo-net-card3'>
                      <img src="/assets/images/kwikwoocomm/frame3.png" alt="" />
                      <div>
                        <h1>500 M+</h1>
                        <p>Delivery status for orders</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : (
              <div className='woo-network'>
                <h1>Tap into GoKwik's <span style={{ border: '3px solid #0285FB', borderRadius: "15px", padding: '0px 5px', boxShadow: "0px 4px 20px 0px #0285fbad" }}>165 M+ Shoppers Network</span></h1>
                <p>Access the largest network of online shoppers to boost engagement and conversions</p>

                <div className='woo-net-card'>
                  <div className='outer'>
                    <div className='inner1 woo-net-card1'>
                      <img src="/assets/images/kwikwoocomm/frame1.png" alt="" />
                      <div>
                        <h1>200+</h1>
                        <p>Signals for risk profiling</p>
                      </div>
                    </div>
                  </div>
                  <div className='outer'>
                    <div className='inner1 woo-net-card2'>
                      <img src="/assets/images/kwikwoocomm/frame2.png" alt="" />
                      <div>
                        <h1>1.5 Bn+</h1>
                        <p>Click stream data points</p>
                      </div>
                    </div>
                  </div>
                  <div className='outer'>
                    <div className='inner1 woo-net-card3'>
                      <img src="/assets/images/kwikwoocomm/frame3.png" alt="" />
                      <div>
                        <h1>500 M+</h1>
                        <p>Delivery status for orders</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>



    </div>



  )
}

export default SectionThree
